import { BagIcon, MedicalIcon, UsersIcon } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { LocalizedLink } from './localized-link.component'
import { twMerge } from 'src/utils/tw-merge.util'
import React from 'react'
import { useCurrentProject } from 'src/providers/current-project.provider'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
} from 'src/pages/configuration/permissions/_components/permissions.type'

type TAreaLink = {
  pathName: string
  label: string
  IconComponent: React.ComponentType<{ className?: string }>
}

export const AreaLinks = ({
  projectId,
  isCollapsed,
  showConfiguration,
}: {
  projectId: number
  isCollapsed: boolean
  showConfiguration: boolean
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { isFeatureActivated, hasAnyPermission } = useCurrentProject()
  // Remove locale prefix from pathname for matching (e.g., /fr/20/medical/dashboard -> /20/medical/dashboard)
  const pathname = location.pathname.replace(/^\/(fr|en)/, '')

  const areaLinks: TAreaLink[] = [
    { pathName: 'medical', label: t('components.navigation.medical'), IconComponent: MedicalIcon },
    ...(isFeatureActivated('is-hr-activated') &&
    hasAnyPermission([{ subject: EPermissionGrantSubjects.HR, action: EPermissionGrantActions.GET }])
      ? [{ pathName: 'hr', label: t('components.navigation.hr'), IconComponent: UsersIcon }]
      : []),
    ...(showConfiguration
      ? [
          {
            pathName: 'configuration',
            label: t('components.navigation.configure-project'),
            IconComponent: BagIcon,
          },
        ]
      : []),
  ]

  return (
    <div
      className={twMerge(
        'c-pb-4 c-mb-4 c-flex c-flex-col c-border-b-solid c-border-b c-border-primary-200 c-mx-5',
        isCollapsed && 'c-mx-4 c-mt-4 c-items-center',
      )}
    >
      {areaLinks.map((areaLink) => {
        const isUserOnThisArea = pathname.includes(`/${areaLink.pathName}/`)
        return (
          <LocalizedLink
            key={areaLink.pathName}
            className={twMerge(
              'c-my-1 c-text-xs c-font-bold c-p-2 c-rounded-md c-text-secondary-850 c-bg-secondary-300 c-opacity-50 c-text-center c-block',
              isUserOnThisArea && 'c-opacity-100',
              isCollapsed && 'c-rounded-full c-flex c-justify-center c-w-max',
            )}
            to={`/${projectId}/${areaLink.pathName}`}
          >
            {isCollapsed ? <areaLink.IconComponent className="c-w-5 c-h-5" /> : areaLink.label}
          </LocalizedLink>
        )
      })}
    </div>
  )
}
